import $ from 'jquery';

const navbarToggle = () => {
    $('.navbar-toggler').each(function () {
        $(this).toggleClass('collapsed');
    });
    if ($('.collapse').hasClass('toggled')) {
        $('body').css('position', ''); // ervoor zorgen dat de website weer gescrolled kan worden
        $('body').css('overflow', ''); // ervoor zorgen dat de website weer gescrolled kan worden
        $(window).scrollTop(window.body_scroll_position); // 'scroll' positie terug zetten naar de waarde die het had voordat de popup geopend was
        $('.collapse').slideUp();
    } else {
        window.body_scroll_position = $(window).scrollTop(); // huidige 'scroll' positie opslaan in een globale window variable
        $('.collapse').slideDown(function() {
            $('body').css('position', 'fixed'); // ervoor zorgen dat de website (dus niet de modal maar de content achter de modal) niet meer gescrolled kan worden, vaak kan je op iOS Safari nog scrollen omdat de navigatiebar (onderaan het scherm) dan weggaat, dit houd dat tegen.
            $('body').css('overflow', 'hidden'); // ervoor zorgen dat de website (dus niet de modal maar de content achter de modal) niet meer gescrolled kan worden, vaak kan je op iOS Safari nog scrollen omdat de navigatiebar (onderaan het scherm) dan weggaat, dit houd dat tegen.
        });
    }
    $('.collapse').toggleClass('toggled');
    // $('.collapse').slideToggle();
}

$(document).on('click', '.navbar-toggler:not(.popup__close__button)', function () {
    navbarToggle();
});
